module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./LED.js"));
	}, "LED");
}